import React from 'react';

import './css/styles.css';

class PanelNosHizoFelizInfo extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            seccion1: {},
            seccion2: {},
            seccion3: {},
        };
    }

    componentWillMount(){
        fetch('/api/uip/nos/hizo/feliz', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    seccion1: response[0],
                    seccion2: response[1],
                    seccion3: response[2],
                })
            })
    }

    render(){
        return(
            <section className="container_nos_hizo_feliz_info">
                <div className="row container_section_nos_hizo_feliz">
                    <div className="row center-align">
                        <span className="nos_hizo_feliz_titulo">{this.state.seccion1.titulo}</span>
                    </div>
                    <div className="row">
                        <div className="container_img_side_to_side">
                            <img src={this.state.seccion1.imagen1}/>
                            <img className="shadow_img2_nos_hizo_feliz" src={this.state.seccion1.imagen2}/>
                        </div>
                    </div>
                </div>
                <div className="row container_section_nos_hizo_feliz_center back_ground_center">
                    <div className="row center-align">
                        <span className="nos_hizo_feliz_titulo">{this.state.seccion2.titulo}</span>
                    </div>
                    <div className="row">
                        <div className="container_img_side_to_side">
                            <img className="shadow_img1_nos_hizo_feliz" src={this.state.seccion2.imagen1}/>
                            <img src={this.state.seccion2.imagen2}/>
                        </div>
                    </div>
                </div>
                <div className="row container_section_nos_hizo_feliz">
                    <div className="row center-align">
                        <span className="nos_hizo_feliz_titulo">{this.state.seccion3.titulo}</span>
                    </div>
                    <div className="row">
                        <div className="container_img_side_to_side">
                            <img src={this.state.seccion3.imagen1}/>
                            <img src={this.state.seccion3.imagen2}/>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PanelNosHizoFelizInfo;